import React from 'react'
import { withPlugin } from '@flamingo_tech/funkgo'
import Pressable from '../../common/Pressable/Pressable'

import styles from './DrawBuoy.module.css'

const DrawBuoy = withPlugin(props => {

  return (
    <div className={styles.couponBuoy} id="draw-buoy-element">
      <Pressable className={styles.content} onClick={() => props.onConfirm(true)} ariaLabel={props.$i18n.transl('core.coupon.drawFlowOpenBuoy')}>
        <span className={styles.chances} aria-hidden="true">x{props.chances}</span>
      </Pressable>
      <Pressable className={styles.close} onClick={() => props.onClose()} ariaLabel={props.$i18n.transl('common.close')}><span aria-hidden="true">&#xe60e;</span></Pressable>
    </div>
  )
})



export default DrawBuoy
